import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Tram Interactions questions
export const tramInteractionsMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-ti-1',
    text: {
      en: 'You are driving and see a tram approaching from behind. What should you do?',
      nl: 'Je rijdt en ziet een tram die van achteren nadert. Wat moet je doen?',
      ar: 'أنت تقود وترى ترام يقترب من الخلف. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-1o1',
        text: {
          en: 'Give way to the tram',
          nl: 'Geef voorrang aan de tram',
          ar: 'أعط الأولوية للترام'
        }
      },
      {
        id: 'q-ti-1o2',
        text: {
          en: 'Continue driving normally',
          nl: 'Blijf normaal rijden',
          ar: 'استمر في القيادة بشكل طبيعي'
        }
      },
      {
        id: 'q-ti-1o3',
        text: {
          en: 'Speed up to avoid the tram',
          nl: 'Versnel om de tram te vermijden',
          ar: 'اسرع لتجنب الترام'
        }
      }
    ],
    correctAnswerId: 'q-ti-1o1',
    explanation: {
      en: 'Trams have priority over other vehicles. You must give way to trams and allow them to pass safely.',
      nl: 'Trams hebben voorrang op andere voertuigen. Je moet voorrang verlenen aan trams en hen veilig laten passeren.',
      ar: 'للترام الأولوية على المركبات الأخرى. يجب عليك إعطاء الأولوية للترام والسماح لهم بالمرور بأمان.'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-2',
    text: {
      en: 'You are driving and see a tram stopped at a tram stop. What should you do?',
      nl: 'Je rijdt en ziet een tram die gestopt is bij een tramhalte. Wat moet je doen?',
      ar: 'أنت تقود وترى ترام متوقف عند محطة ترام. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-2o1',
        text: {
          en: 'Stop and wait for passengers to board/alight',
          nl: 'Stop en wacht tot passagiers instappen/uitstappen',
          ar: 'توقف وانتظر حتى يصعد/ينزل الركاب'
        }
      },
      {
        id: 'q-ti-2o2',
        text: {
          en: 'Continue driving past the tram',
          nl: 'Blijf langs de tram rijden',
          ar: 'استمر في القيادة بجانب الترام'
        }
      },
      {
        id: 'q-ti-2o3',
        text: {
          en: 'Honk to warn passengers',
          nl: 'Toeter om passagiers te waarschuwen',
          ar: 'استخدم البوق لتحذير الركاب'
        }
      }
    ],
    correctAnswerId: 'q-ti-2o1',
    explanation: {
      en: 'When a tram is stopped at a tram stop, you must stop and wait for passengers to safely board or alight before proceeding.',
      nl: 'Wanneer een tram gestopt is bij een tramhalte, moet je stoppen en wachten tot passagiers veilig instappen of uitstappen voordat je doorgaat.',
      ar: 'عندما يكون الترام متوقفا عند محطة ترام، يجب عليك التوقف وانتظار صعود أو نزول الركاب بأمان قبل المتابعة.'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-3',
    text: {
      en: 'You are driving and see a tram crossing your path. What should you do?',
      nl: 'Je rijdt en ziet een tram die je pad kruist. Wat moet je doen?',
      ar: 'أنت تقود وترى ترام يعبر مسارك. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-3o1',
        text: {
          en: 'Give way to the tram',
          nl: 'Geef voorrang aan de tram',
          ar: 'أعط الأولوية للترام'
        }
      },
      {
        id: 'q-ti-3o2',
        text: {
          en: 'Continue driving, trams must give way',
          nl: 'Blijf rijden, trams moeten voorrang verlenen',
          ar: 'استمر في القيادة، يجب على الترام إعطاء الأولوية'
        }
      },
      {
        id: 'q-ti-3o3',
        text: {
          en: 'Speed up to cross before the tram',
          nl: 'Versnel om voor de tram over te steken',
          ar: 'اسرع للعبور قبل الترام'
        }
      }
    ],
    correctAnswerId: 'q-ti-3o1',
    explanation: {
      en: 'Trams have priority at intersections and crossings. You must give way to trams and wait for them to pass.',
      nl: 'Trams hebben voorrang bij kruisingen en oversteekplaatsen. Je moet voorrang verlenen aan trams en wachten totdat ze passeren.',
      ar: 'للترام الأولوية عند التقاطعات والمعابر. يجب عليك إعطاء الأولوية للترام وانتظار مرورهم.'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-4',
    text: {
      en: 'You are driving on a road with tram tracks. What should you do?',
      nl: 'Je rijdt op een weg met tramsporen. Wat moet je doen?',
      ar: 'أنت تقود على طريق به قضبان ترام. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-4o1',
        text: {
          en: 'Drive carefully and be aware of trams',
          nl: 'Rijd voorzichtig en let op trams',
          ar: 'اقود بحذر وكن على علم بالترام'
        }
      },
      {
        id: 'q-ti-4o2',
        text: {
          en: 'Drive normally, trams will avoid you',
          nl: 'Rijd normaal, trams zullen je vermijden',
          ar: 'اقود بشكل طبيعي، الترام سيتجنبك'
        }
      },
      {
        id: 'q-ti-4o3',
        text: {
          en: 'Avoid driving on roads with tram tracks',
          nl: 'Vermijd rijden op wegen met tramsporen',
          ar: 'تجنب القيادة على الطرق ذات قضبان الترام'
        }
      }
    ],
    correctAnswerId: 'q-ti-4o1',
    explanation: {
      en: 'When driving on roads with tram tracks, drive carefully and be constantly aware of trams that may be approaching.',
      nl: 'Bij het rijden op wegen met tramsporen moet je voorzichtig rijden en constant letten op trams die mogelijk naderen.',
      ar: 'عند القيادة على الطرق ذات قضبان الترام، اقود بحذر وكن على علم دائم بالترام الذي قد يقترب.'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-6',
    text: {
      en: 'You are driving and see a tram approaching from the opposite direction. What should you do?',
      nl: 'Je rijdt en ziet een tram die van de tegenovergestelde richting nadert. Wat moet je doen?',
      ar: 'أنت تقود وترى ترام يقترب من الاتجاه المعاكس. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-6o1',
        text: {
          en: 'Drive normally, trams have their own lane',
          nl: 'Rijd normaal, trams hebben hun eigen rijstrook',
          ar: 'اقود بشكل طبيعي، الترام له ممره الخاص'
        }
      },
      {
        id: 'q-ti-6o2',
        text: {
          en: 'Give extra space to the tram',
          nl: 'Geef extra ruimte aan de tram',
          ar: 'أعط مساحة إضافية للترام'
        }
      },
      {
        id: 'q-ti-6o3',
        text: {
          en: 'Stop completely and let the tram pass',
          nl: 'Stop volledig en laat de tram passeren',
          ar: 'توقف تماما واسمح للترام بالمرور'
        }
      }
    ],
    correctAnswerId: 'q-ti-6o2',
    explanation: {
      en: 'When a tram is approaching from the opposite direction, give it extra space and be prepared to stop if necessary.',
      nl: 'Wanneer een tram van de tegenovergestelde richting nadert, geef hem extra ruimte en wees bereid om indien nodig te stoppen.',
      ar: 'عندما يقترب الترام من الاتجاه المعاكس، أعطه مساحة إضافية وكن مستعدا للتوقف إذا لزم الأمر.'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-7',
    text: {
      en: 'You are driving and see a tram making a turn. What should you do?',
      nl: 'Je rijdt en ziet een tram die een bocht maakt. Wat moet je doen?',
      ar: 'أنت تقود وترى ترام يقوم بالانعطاف. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-7o1',
        text: {
          en: 'Give way to the tram',
          nl: 'Geef voorrang aan de tram',
          ar: 'أعط الأولوية للترام'
        }
      },
      {
        id: 'q-ti-7o2',
        text: {
          en: 'Continue driving, trams must give way',
          nl: 'Blijf rijden, trams moeten voorrang verlenen',
          ar: 'استمر في القيادة، يجب على الترام إعطاء الأولوية'
        }
      },
      {
        id: 'q-ti-7o3',
        text: {
          en: 'Speed up to avoid the tram',
          nl: 'Versnel om de tram te vermijden',
          ar: 'اسرع لتجنب الترام'
        }
      }
    ],
    correctAnswerId: 'q-ti-7o1',
    explanation: {
      en: 'Trams have priority when making turns. You must give way to trams and wait for them to complete their turn.',
      nl: 'Trams hebben voorrang bij het maken van bochten. Je moet voorrang verlenen aan trams en wachten totdat ze hun bocht hebben voltooid.',
      ar: 'للترام الأولوية عند الانعطاف. يجب عليك إعطاء الأولوية للترام وانتظار إكماله للانعطاف.'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-8',
    text: {
      en: 'You are driving and see a tram at a tram stop with passengers boarding. What should you do?',
      nl: 'Je rijdt en ziet een tram bij een tramhalte met instappende passagiers. Wat moet je doen?',
      ar: 'أنت تقود وترى ترام عند محطة ترام مع ركاب يصعدون. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-8o1',
        text: {
          en: 'Stop and wait for the tram to depart',
          nl: 'Stop en wacht tot de tram vertrekt',
          ar: 'توقف وانتظر حتى يغادر الترام'
        }
      },
      {
        id: 'q-ti-8o2',
        text: {
          en: 'Continue driving past the tram',
          nl: 'Blijf langs de tram rijden',
          ar: 'استمر في القيادة بجانب الترام'
        }
      },
      {
        id: 'q-ti-8o3',
        text: {
          en: 'Honk to warn passengers',
          nl: 'Toeter om passagiers te waarschuwen',
          ar: 'استخدم البوق لتحذير الركاب'
        }
      }
    ],
    correctAnswerId: 'q-ti-8o1',
    explanation: {
      en: 'When a tram is at a stop with passengers boarding, you must stop and wait for the tram to depart before proceeding.',
      nl: 'Wanneer een tram bij een halte staat met instappende passagiers, moet je stoppen en wachten totdat de tram vertrekt voordat je doorgaat.',
      ar: 'عندما يكون الترام عند محطة مع ركاب يصعدون، يجب عليك التوقف وانتظار مغادرة الترام قبل المتابعة.'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-10',
    text: {
      en: 'You are driving and see a tram with a red light. What should you do?',
      nl: 'Je rijdt en ziet een tram met een rood licht. Wat moet je doen?',
      ar: 'أنت تقود وترى ترام بضوء أحمر. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-10o1',
        text: {
          en: 'Give way to the tram',
          nl: 'Geef voorrang aan de tram',
          ar: 'أعط الأولوية للترام'
        }
      },
      {
        id: 'q-ti-10o2',
        text: {
          en: 'Continue driving normally',
          nl: 'Blijf normaal rijden',
          ar: 'استمر في القيادة بشكل طبيعي'
        }
      },
      {
        id: 'q-ti-10o3',
        text: {
          en: 'Honk to warn the tram driver',
          nl: 'Toeter om de trambestuurder te waarschuwen',
          ar: 'استخدم البوق لتحذير سائق الترام'
        }
      }
    ],
    correctAnswerId: 'q-ti-10o1',
    explanation: {
      en: 'Trams with red lights have priority and may be making an emergency stop. You must give way to them immediately.',
      nl: 'Trams met rode lichten hebben voorrang en kunnen mogelijk een noodstop maken. Je moet hen onmiddellijk voorrang verlenen.',
      ar: 'الترام ذو الأضواء الحمراء له الأولوية وقد يقوم بتوقف طارئ. يجب عليك إعطاء الأولوية لهم فورا.'
    },
    subject: 'Tram Interactions'
  }
  ,
  {
    id: 'q-ti-11',
    text: {
      en: 'You want to turn left across tram tracks. A tram is approaching from the opposite direction. What should you do?',
      nl: 'U wilt linksaf slaan over tramsporen. Een tram komt uit de tegenovergestelde richting. Wat moet u doen?',
      ar: 'تريد الانعطاف يساراً لعبور مسارات الترام. يوجد ترام يقترب من الاتجاه المعاكس. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-11o1',
        text: {
          en: 'Give way to the tram; wait until it has passed',
          nl: 'Voorrang verlenen aan de tram; wachten tot deze is gepasseerd',
          ar: 'فسح الطريق للترام والانتظار حتى يمر'
        }
      },
      {
        id: 'q-ti-11o2',
        text: {
          en: 'Turn quickly before the tram arrives',
          nl: 'Snel linksaf slaan voordat de tram komt',
          ar: 'انعطف بسرعة قبل وصول الترام'
        }
      },
      {
        id: 'q-ti-11o3',
        text: {
          en: 'Honk and then turn',
          nl: 'Claxonneren en dan pas afslaan',
          ar: 'استخدم البوق ثم انعطف'
        }
      }
    ],
    correctAnswerId: 'q-ti-11o1',
    explanation: {
      en: 'When turning across tram tracks, you must give way to trams. Wait until the tram has passed before completing your turn. (RVV 1990 art. 3)',
      nl: 'Bij het afslaan over tramsporen moet u voorrang verlenen aan trams. Wacht tot de tram is gepasseerd voordat u uw bocht voltooit. (RVV 1990 art. 3)',
      ar: 'عند الانعطاف لعبور مسارات الترام يجب أن تفسح الطريق للترام. انتظر حتى يمر الترام قبل إكمال انعطافك. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-12',
    text: {
      en: 'You are at a junction. A tram is approaching from your right. Who has priority?',
      nl: 'U bent bij een kruising. Een tram nadert van rechts. Wie heeft voorrang?',
      ar: 'أنت عند تقاطع. ترام يقترب من يمينك. من صاحب الأولوية؟'
    },
    options: [
      {
        id: 'q-ti-12o1',
        text: {
          en: 'You have priority; priority to the right does not apply to trams',
          nl: 'U heeft voorrang; voorrang van rechts geldt niet voor trams',
          ar: 'أنت صاحب الأولوية؛ أولوية اليمين لا تنطبق على الترام'
        }
      },
      {
        id: 'q-ti-12o2',
        text: {
          en: 'The tram has priority; you must give way',
          nl: 'De tram heeft voorrang; u moet voorrang verlenen',
          ar: 'الترام لديه الأولوية؛ يجب أن تفسح الطريق'
        }
      },
      {
        id: 'q-ti-12o3',
        text: {
          en: 'Whoever arrives first has priority',
          nl: 'Wie het eerst komt, heeft voorrang',
          ar: 'صاحب الوصول أولاً لديه الأولوية'
        }
      }
    ],
    correctAnswerId: 'q-ti-12o2',
    explanation: {
      en: 'Trams have priority at junctions over other traffic. You must give way to the tram approaching from your right. (RVV 1990 art. 3)',
      nl: 'Trams hebben op kruisingen voorrang op ander verkeer. U moet voorrang verlenen aan de tram die van rechts nadert. (RVV 1990 art. 3)',
      ar: 'للترام أولوية عند التقاطعات على باقي حركة المرور. يجب عليك فسح الطريق للترام القادم من يمينك. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-13',
    text: {
      en: 'You are driving in a lane shared with tram tracks. A tram is behind you. What should you do?',
      nl: 'U rijdt in een rijstrook die gedeeld is met tramsporen. Een tram rijdt achter u. Wat moet u doen?',
      ar: 'أنت تقود في حارة مشتركة مع مسارات الترام. الترام خلفك. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-13o1',
        text: {
          en: 'Speed up to stay ahead of the tram',
          nl: 'Sneller rijden om voor de tram te blijven',
          ar: 'زد السرعة لتبقى أمام الترام'
        }
      },
      {
        id: 'q-ti-13o2',
        text: {
          en: 'Allow the tram to pass when safe; move aside if possible or continue at a steady speed',
          nl: 'De tram laten passeren wanneer dat veilig is; zo mogelijk opzij gaan of gelijkmatig doorrijden',
          ar: 'اسمح للترام بالمرور عندما يكون ذلك آمناً؛ وإن أمكن تحرك جانباً أو استمر بسرعة ثابتة'
        }
      },
      {
        id: 'q-ti-13o3',
        text: {
          en: 'Stop immediately in the lane',
          nl: 'Onmiddellijk in de rijstrook stoppen',
          ar: 'توقف فوراً في الحارة'
        }
      }
    ],
    correctAnswerId: 'q-ti-13o2',
    explanation: {
      en: 'In a shared lane, allow the tram to pass when it is safe. If you can move aside without endangering others, do so; otherwise continue at a steady speed so the tram can follow or pass when the road widens. (RVV 1990 art. 3)',
      nl: 'In een gedeelde rijstrook laat u de tram passeren wanneer dat veilig is. Ga zo mogelijk zonder anderen in gevaar te brengen opzij; anders rijdt u gelijkmatig door zodat de tram kan volgen of inhalen wanneer de weg breder wordt. (RVV 1990 art. 3)',
      ar: 'في حارة مشتركة، اسمح للترام بالمرور عندما يكون ذلك آمناً. إذا استطعت التحرك جانباً دون تعريض الآخرين للخطر، افعل ذلك؛ وإلا فاستمر بسرعة ثابتة كي يتمكن الترام من المتابعة أو المرور عندما يتسع الطريق. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-14',
    text: {
      en: 'A tram has stopped at a stop in the middle of the road. Passengers are crossing to the pavement. What should you do?',
      nl: 'Een tram staat stil bij een halte midden op de weg. Passagiers steken naar het trottoir over. Wat moet u doen?',
      ar: 'توقف الترام عند محطة في وسط الطريق. الركاب يعبرون إلى الرصيف. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-14o1',
        text: {
          en: 'Stop and wait until the tram moves and the crossing is clear',
          nl: 'Stoppen en wachten tot de tram vertrekt en het oversteken vrij is',
          ar: 'توقف وانتظر حتى يتحرك الترام ويصبح المعبر خالياً'
        }
      },
      {
        id: 'q-ti-14o2',
        text: {
          en: 'Drive past slowly; pedestrians must wait',
          nl: 'Langzaam voorbijrijden; voetgangers moeten wachten',
          ar: 'مر ببطء؛ يجب أن ينتظر المشاة'
        }
      },
      {
        id: 'q-ti-14o3',
        text: {
          en: 'Honk so pedestrians hurry',
          nl: 'Claxonneren zodat voetgangers opschieten',
          ar: 'استخدم البوق ليعجل المشاة'
        }
      }
    ],
    correctAnswerId: 'q-ti-14o1',
    explanation: {
      en: 'When a tram has stopped and passengers are crossing the road to or from the tram, you must stop and wait until they have crossed and the tram has moved off if necessary. (RVV 1990 art. 3)',
      nl: 'Als een tram stilstaat en passagiers de weg over naar of van de tram, moet u stoppen en wachten tot zij zijn overgestoken en de tram indien nodig is weggereden. (RVV 1990 art. 3)',
      ar: 'عندما يتوقف الترام ويعبر الركاب الطريق من/إلى الترام، يجب أن تتوقف وتنتظر حتى يعبروا، وإذا لزم الأمر حتى يتحرك الترام. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-16',
    text: {
      en: 'At a junction, the traffic lights are green for you. A tram is also approaching the junction and has a green light. What should you do?',
      nl: 'Op een kruising staan de verkeerslichten voor u op groen. Een tram nadert het kruisingspunt en heeft ook groen. Wat moet u doen?',
      ar: 'عند تقاطع، إشارة المرور خضراء لك. كما يقترب الترام من التقاطع وهو أيضاً لديه إشارة خضراء. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-16o1',
        text: {
          en: 'Proceed; you both have green',
          nl: 'Doorrijden; u heeft allebei groen',
          ar: 'تابع السير؛ كلاكما لديه إشارة خضراء'
        }
      },
      {
        id: 'q-ti-16o2',
        text: {
          en: 'Give way to the tram; trams have priority when both have green',
          nl: 'Voorrang verlenen aan de tram; trams hebben voorrang als u allebei groen hebt',
          ar: 'فسح الطريق للترام؛ الترام لديه أولوية عندما تكون الإشارتان خضراء'
        }
      },
      {
        id: 'q-ti-16o3',
        text: {
          en: 'Stop and wait for the tram to pass',
          nl: 'Stoppen en wachten tot de tram is gepasseerd',
          ar: 'توقف وانتظر حتى يمر الترام'
        }
      }
    ],
    correctAnswerId: 'q-ti-16o2',
    explanation: {
      en: 'When you and a tram both have a green light, the tram has priority. You must give way to the tram before proceeding. (RVV 1990 art. 3)',
      nl: 'Als u en een tram allebei groen hebben, heeft de tram voorrang. U moet de tram voor laten gaan voordat u verder rijdt. (RVV 1990 art. 3)',
      ar: 'عندما تكون لك وللترام إشارة خضراء، يكون للترام أولوية. يجب أن تفسح الطريق للترام قبل المتابعة. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-17',
    text: {
      en: 'You are waiting to turn right. A tram is going straight ahead on the same road. Who has priority?',
      nl: 'U wacht om rechtsaf te slaan. Een tram rijdt op dezelfde weg rechtdoor. Wie heeft voorrang?',
      ar: 'أنت تنتظر للانعطاف يميناً. الترام يسير مستقيمًا على نفس الطريق. من لديه الأولوية؟'
    },
    options: [
      {
        id: 'q-ti-17o1',
        text: {
          en: 'You have priority when turning right',
          nl: 'U heeft voorrang bij rechtsaf',
          ar: 'أنت صاحب الأولوية عند الانعطاف يميناً'
        }
      },
      {
        id: 'q-ti-17o2',
        text: {
          en: 'The tram has priority; you must give way',
          nl: 'De tram heeft voorrang; u moet voorrang verlenen',
          ar: 'الترام لديه الأولوية؛ يجب أن تفسح الطريق'
        }
      },
      {
        id: 'q-ti-17o3',
        text: {
          en: 'Whoever moves first has priority',
          nl: 'Wie het eerst beweegt, heeft voorrang',
          ar: 'من يتحرك أولاً لديه الأولوية'
        }
      }
    ],
    correctAnswerId: 'q-ti-17o2',
    explanation: {
      en: 'Trams going straight ahead have priority over vehicles turning. You must wait for the tram to pass before turning right. (RVV 1990 art. 3)',
      nl: 'Trams die rechtdoor rijden hebben voorrang op afslaand verkeer. U moet wachten tot de tram is gepasseerd voordat u rechtsaf slaat. (RVV 1990 art. 3)',
      ar: 'للترام الذي يسير مستقيمًا أولوية على المركبات التي ستنعطف. يجب أن تنتظر حتى يمر الترام قبل الانعطاف يميناً. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-18',
    text: {
      en: 'A tram is reversing into a depot. What should you do?',
      nl: 'Een tram zet achteruit richting een remise. Wat moet u doen?',
      ar: 'يتراجع الترام إلى المستودع. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-18o1',
        text: {
          en: 'Give way and wait; do not pass the reversing tram',
          nl: 'Voorrang verlenen en wachten; niet inhalen bij een achteruitrijdende tram',
          ar: 'فسح الطريق وانتظر؛ لا تمر بجانب الترام وهو يتراجع'
        }
      },
      {
        id: 'q-ti-18o2',
        text: {
          en: 'Pass quickly before it blocks the road',
          nl: 'Snel passeren voordat de weg geblokkeerd is',
          ar: 'مر بسرعة قبل أن يعيق الطريق'
        }
      },
      {
        id: 'q-ti-18o3',
        text: {
          en: 'Honk to warn the tram driver',
          nl: 'Claxonneren om de trambestuurder te waarschuwen',
          ar: 'استخدم البوق لتحذير سائق الترام'
        }
      }
    ],
    correctAnswerId: 'q-ti-18o1',
    explanation: {
      en: 'When a tram is reversing, give way and wait. Do not try to pass; wait until the tram has completed its manoeuvre. (RVV 1990 art. 3)',
      nl: 'Als een tram achteruit rijdt, verleent u voorrang en wacht u. Probeer niet in te halen; wacht tot de tram zijn manoeuvre heeft voltooid. (RVV 1990 art. 3)',
      ar: 'عندما يتراجع الترام، فسح الطريق وانتظر. لا تحاول المرور؛ انتظر حتى يكمل مناورة التراجع. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  },
  {
    id: 'q-ti-21',
    text: {
      en: 'A tram has just left a stop and is moving slowly. You are behind it. What should you do?',
      nl: 'Een tram is zojuist van een halte vertrokken en rijdt langzaam. U rijdt erachter. Wat moet u doen?',
      ar: 'غادر الترام للتو محطة وهو يتحرك ببطء. أنت خلفه. ماذا يجب أن تفعل؟'
    },
    options: [
      {
        id: 'q-ti-21o1',
        text: {
          en: 'Overtake as soon as possible',
          nl: 'Zo snel mogelijk inhalen',
          ar: 'تجاوز الترام في أقرب وقت ممكن'
        }
      },
      {
        id: 'q-ti-21o2',
        text: {
          en: 'Stay behind at a safe distance; do not overtake unless the tram has stopped or you have a clear dedicated lane',
          nl: 'Op veilige afstand achter blijven; niet inhalen tenzij de tram stilstaat of u een duidelijke vrije strook heeft',
          ar: 'ابق خلفه بمسافة آمنة؛ لا تتجاوز إلا إذا توقف الترام أو كان لديك حارة مخصصة واضحة'
        }
      },
      {
        id: 'q-ti-21o3',
        text: {
          en: 'Honk to make it go faster',
          nl: 'Claxonneren om hem sneller te laten gaan',
          ar: 'استخدم البوق ليذهب أسرع'
        }
      }
    ],
    correctAnswerId: 'q-ti-21o2',
    explanation: {
      en: 'Do not overtake a tram that has just left a stop until it is safe and allowed. Passengers may still be near the road; the tram may stop again. Keep a safe distance. (RVV 1990 art. 3)',
      nl: 'Haal een tram die net van een halte vertrekt niet in voordat dat veilig en toegestaan is. Passagiers kunnen nog nabij de rijbaan zijn; de tram kan weer stoppen. Houd voldoende afstand. (RVV 1990 art. 3)',
      ar: 'لا تتجاوز تراماً غادر للتو محطة حتى يصبح ذلك آمناً ومسموحاً. قد يظل الركاب قريبين من الطريق وقد يتوقف الترام مرة أخرى. حافظ على مسافة آمنة. (قانون المرور الهولندي 1990، المادة 3)'
    },
    subject: 'Tram Interactions'
  }
];

























